// extracted by mini-css-extract-plugin
module.exports = {"plateWrapper":"Plate_plateWrapper__l3JpG","icon":"Plate_icon__2suZi","header":"Plate_header__u-gBQ","subHeader":"Plate_subHeader__3725o"};